import { render, staticRenderFns } from "./BasicsWarehouse.vue?vue&type=template&id=34bd42b0&scoped=true"
import script from "./BasicsWarehouse.vue?vue&type=script&lang=js"
export * from "./BasicsWarehouse.vue?vue&type=script&lang=js"
import style0 from "./BasicsWarehouse.vue?vue&type=style&index=0&id=34bd42b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34bd42b0",
  null
  
)

export default component.exports